import React, {Fragment, Suspense} from 'react';
import MasterLayout from "../../components/MasterLayout/MasterLayout";
import LazyLoader from "../../components/MasterLayout/LazyLoader";
import BankList from "../../components/Bank/BankList";
const BankListPage = () => {
    return (
        <Fragment>
            <MasterLayout>
                <Suspense fallback={<LazyLoader/>}>
                    <BankList/>
                </Suspense>
            </MasterLayout>
        </Fragment>
    );
};
export default BankListPage;